import { Button, Flex, Form } from "antd"
import { spacings } from "themes/variables"
import { useTranslation } from "react-i18next"
import PropTypes from "prop-types"
import styles from "../index.module.css"

const ProfileActionButtons = ({ handleProfileCancel }) => {
  const { t } = useTranslation()
  const form = Form.useFormInstance()
  const profileFields = [
    "avatar",
    "first_name",
    "last_name",
    "gender",
    "birthday",
    "street_address",
    "city",
    "state",
    "zip_code",
    "country"
  ]
  return (
    <Flex gap={spacings.S} className={`my-3xl ${styles.actionButtons}`} >
      <Button variant="outlined" color="primary" className="p-l" onClick={handleProfileCancel}>
        {t("global.cancel")}
      </Button>
      <Form.Item noStyle shouldUpdate>
        {() => {
          const isTouched = form.isFieldsTouched(profileFields)
          return (
            <Button type="primary" className="p-l" htmlType="submit" disabled={!isTouched}>
              {t("client.profile.tabs.profile.save_changes")}
            </Button>
          )
        }}
      </Form.Item>
    </Flex>
  )
}

ProfileActionButtons.propTypes = {
  handleProfileCancel: PropTypes.func.isRequired
}

export default ProfileActionButtons
